import clsx from 'clsx';

import BaseSanitizer from '@components/base/BaseSanitizer';

import styles from './StrengthCard.module.scss';

interface IStrengthCardProps {
    imgSrc: string;
    title: string;
    text: string;
    isLast?: boolean;
}

const StrengthCard: React.FC<IStrengthCardProps> = ({ imgSrc, title, text, isLast }) => {
    return (
        <div className={clsx(styles.StrengthCard, { [styles.StrengthCard__last]: isLast })}>
            <div className={styles.StrengthCard_mobileImg}>
                <img src={imgSrc} alt={text} />
            </div>
            <div className={styles.StrengthCard_text}>
                <div className={styles.StrengthCard_text_title}>
                    <div className={styles.StrengthCard_text_desktopImg}>
                        <img src={imgSrc} alt={text} />
                    </div>
                    <BaseSanitizer html={title} tag="h4" />
                </div>
                <BaseSanitizer html={text} tag="p" />
            </div>
        </div>
    );
};

export default StrengthCard;
